module.exports = "<div class=\"inline-block\">\n  <span class=\"y-switch\" data-bind = \"css:sizeClass, click: checkSelect,attr:{fieldid: fieldid}\" >\n    <input type=\"hidden\" value=\"false\">\n    <span class=\"y-switch-inner\">\n          <!-- ko template: { nodes: $componentTemplateNodes } --><!-- /ko -->\n    </span>\n  </span>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/switch/index.html
// module id = 489
// module chunks = 0